import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { Combo2Service, MenuMappingService, SalesInvoiceService } from "../../../services";
import { WhWorkOrderService } from "../../../services/whWorkOrder.service";

@Component({
  selector: "addWhWorkOrderAssign",
  templateUrl: "./addWhWorkOrderAssign.html",
})
export class addWhWorkOrderAssign {
  data: any;
  mode: string;
  saveEvent: any;
  isLoading: boolean = false;
  showForm: boolean = false;
  isStockMode: boolean = false; // New flag to distinguish between assign and stock mode

  // Lists for dropdowns
  userList: any[] = [];
  partyList: any[] = [];
  partyAssignedList: any[] = []; // For table display
  styleList: string[] = ["FORMAL", "CASUAL", "RR FORMAL", "RR CASUAL"];

  // Stock data
  stockList: any[] = [];
  stockSummary: any = {
    totalItems: 0,
    cancelledItems: 0,
    availableItems: 0,
    totalPieces: 0,
    cancelledPieces: 0,
    availablePieces: 0,
    totalBags: 0,
    totalIndividual: 0,
    availableBags: 0,
    availableIndividual: 0,
    totalFs: 0,
    totalHs: 0,
  };
  selectedPartyForStock: any = null;

  // Form data
  formData = {
    "partyName": "",
    "partyID": "",
    "style": "",
    "username": "",
    "userID": "",
    "assignedQty": 0,
    "formalPieces": 0,
    "casualPieces": 0
  };

  selectedStockItems: Set<any> = new Set(); // Track selected items
  selectAll: boolean = false; // Master checkbox state

  partySearchText: string = '';

  get filteredPartyAssignedList(): any[] {
    const search = this.partySearchText.trim().toLowerCase();
    let list = this.partyAssignedList;
    if (search) {
      list = list.filter(party => (party.name || '').toLowerCase().includes(search));
    }
    return list.slice().sort((a, b) => (a.name || '').localeCompare(b.name || ''));
  }

  partyListSummary = {
    totalAssignedPcs: 0,
    totalFormalPcs: 0,
    totalCasualPcs: 0,
    totalRrFormalPcs: 0,
    totalRrCasualPcs: 0,
    totalFsPcs: 0,
    totalHsPcs: 0,
  }

  @Input() set params(val: any[]) {
    this.mode = val["mode"];
    let data = Object.assign({}, val["data"]);
    this.data = data;
    console.log('addWhWorkOrderAssign data :: ', this.data);
    this.saveEvent = val["data"].tabevent;
  }

  @Output() tabUpdateEvent = new EventEmitter();

  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    public MappingService: MenuMappingService,
    private salesinvservice: SalesInvoiceService,
    private combo: Combo2Service,
    private whWorkOrderService: WhWorkOrderService
  ) {
    this.data = {};
  }

  ngOnInit() {
    this.getUserList();
    this.getPartywiseAssignedDetails();
  }

  ngAfterViewInit() {
    // Focus logic if needed
  }

  getUserList() {
    this.MappingService.getUserList({}).then((res: any) => {
      this.userList = res.data || [];
    }).catch((error: any) => {
      console.error('Error fetching user list:', error);
      this.userList = [];
    });
  }

  getPartywiseAssignedDetails() {
    this.whWorkOrderService.getPartywiseAssignedDetails().then((res: any) => {
      if (res && res.success && res.data) {
        // Store original data for table display
        this.partyAssignedList = res.data;

        // Transform the data to include display name for typeahead
        this.partyList = res.data.map(party => ({
          ...party,
          displayName: `${party.name} (${party.assignedPieces})`
        }));

        // Calculate totals and store in variables
        this.calculatePartySummaryTotals();

      } else {
        this.partyAssignedList = [];
        this.partyList = [];
        this.resetPartySummaryTotals();
      }
    }).catch((error: any) => {
      console.error('Error fetching party assigned details:', error);
      this.partyAssignedList = [];
      this.partyList = [];
      this.resetPartySummaryTotals();
    });
  }

  // Method to calculate all summary totals
  calculatePartySummaryTotals() {
    this.partyListSummary = {
      totalAssignedPcs: 0,
      totalFormalPcs: 0,
      totalCasualPcs: 0,
      totalRrFormalPcs: 0,
      totalRrCasualPcs: 0,
      totalFsPcs: 0,
      totalHsPcs: 0,
    };

    this.partyAssignedList.forEach(party => {
      this.partyListSummary.totalAssignedPcs += Number(party.assignedPieces || 0);
      this.partyListSummary.totalFormalPcs += Number(party.formalPieces || 0);
      this.partyListSummary.totalCasualPcs += Number(party.casualPieces || 0);
      this.partyListSummary.totalRrFormalPcs += Number(party.rrFormalPieces || 0);
      this.partyListSummary.totalRrCasualPcs += Number(party.rrCasualPieces || 0);
      this.partyListSummary.totalFsPcs += Number(party.totalFs || 0);
      this.partyListSummary.totalHsPcs += Number(party.totalHs || 0);
    });
  }

  resetPartySummaryTotals() {
    this.partyListSummary = {
      totalAssignedPcs: 0,
      totalFormalPcs: 0,
      totalCasualPcs: 0,
      totalRrFormalPcs: 0,
      totalRrCasualPcs: 0,
      totalFsPcs: 0,
      totalHsPcs: 0,
    };
  }

  getPartyList() {
    let params = { start: 0, limit: 100, page: 1 };
    this.salesinvservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
    });
  }

  userOnSelect(ev: any) {
    if (ev && ev.item) {
      this.formData.userID = ev.item.userid || '';
    }
  }

  partyOnSelect(ev: any) {
    if (ev && ev.item) {
      const selectedParty = ev.item;
      this.formData.partyID = selectedParty.party_id || '';
      this.formData.assignedQty = selectedParty.assignedPieces || 0;
      this.formData.formalPieces = selectedParty.formalPieces || 0;
      this.formData.casualPieces = selectedParty.casualPieces || 0;
    }
  }

  // Method to handle assign button click
  onAssignParty(party: any) {
    this.isStockMode = false;
    // Pre-fill the form with selected party data
    this.formData.partyName = party.name;
    this.formData.partyID = party.party_id;
    this.formData.assignedQty = party.assignedPieces;
    this.formData.formalPieces = party.formalPieces;
    this.formData.casualPieces = party.casualPieces;

    // Store selected party for stock loading
    this.selectedPartyForStock = party;

    // Load stock data for the selected party
    this.getStockByParty(party.party_id);

    // Show the form
    this.showForm = true;
  }

  // NEW: Method to handle stock button click
  onStockParty(party: any) {
    this.isStockMode = true;
    // Pre-fill the form with selected party data
    this.formData.partyName = party.name;
    this.formData.partyID = party.party_id;
    this.formData.assignedQty = party.assignedPieces;
    this.formData.formalPieces = party.formalPieces;
    this.formData.casualPieces = party.casualPieces;

    // Store selected party for stock loading
    this.selectedPartyForStock = party;

    // Load stock data for the selected party
    this.getStockByParty(party.party_id);

    // Show the form
    this.showForm = true;
  }

  // Get stock data by party ID
  getStockByParty(party_id: number) {
    this.isLoading = true;

    this.whWorkOrderService.getStockByParty({ party_id })
      .then((res: any) => {
        this.isLoading = false;

        if (res && res.success) {
          this.stockList = res.data.stock || [];
          this.stockSummary = res.data.summary || this.stockSummary;

          // Nothing is selected to begin with - the user picks the rows to assign.
          this.selectedStockItems.clear();
          this.selectAll = false;

          // Initialize is_cancelled to 0 if not set
          this.stockList.forEach(item => {
            if (item.is_cancelled === null || item.is_cancelled === undefined) {
              item.is_cancelled = 0;
            }
            // For stock mode, we'll use is_cancelled flag to represent unlocked status
            // is_cancelled = 1 means unlocked (will be processed)
          });

          // Update summary counts
          this.updateStockSummary();

        } else {
          this.stockList = [];
          this.toasterService.pop({
            bodyOutputType: 1,
            type: "warning",
            title: "WARNING",
            body: res.message || "Failed to load stock data",
          });
        }
      })
      .catch((error: any) => {
        this.isLoading = false;
        this.stockList = [];

        let errorMessage = "Failed to load stock data";
        try {
          const errorResponse = JSON.parse(error._body);
          errorMessage = errorResponse.message || errorMessage;
        } catch (e) {
          // Use default message
        }

        this.toasterService.pop({
          bodyOutputType: 1,
          type: "error",
          title: "ERROR",
          body: errorMessage,
        });
      });
  }

  // Update stock summary counts based on current stock list
  updateStockSummary() {
    const cancelledItems = this.stockList.filter(item => item.is_cancelled == 1);
    const availableItems = this.stockList.filter(item => item.is_cancelled != 1);

    // Calculate pieces (sum of pcs field)
    const cancelledPieces = cancelledItems.reduce((sum, item) => sum + parseInt(item.pcs || 0), 0);
    const availablePieces = availableItems.reduce((sum, item) => sum + parseInt(item.pcs || 0), 0);

    // Calculate bags and individual counts (only for available items)
    const availableBags = availableItems.filter(item => item.bagNo).length;
    const availableIndividual = availableItems.filter(item => !item.bagNo).length;

    this.stockSummary = {
      ...this.stockSummary,
      cancelledPieces: cancelledPieces,
      availablePieces: availablePieces,
      totalPieces: cancelledPieces + availablePieces,
      availableBags: availableBags,
      availableIndividual: availableIndividual,
      totalItems: this.stockList.length,
      cancelledItems: cancelledItems.length,
      availableItems: availableItems.length
    };

    // Update the selected party's counts as well
    if (this.selectedPartyForStock) {
      this.selectedPartyForStock.availableQty = availablePieces;
      this.selectedPartyForStock.cancelledQty = cancelledPieces;
    }
  }

  // Method to show new assignment form
  showNewAssignmentForm() {
    this.isStockMode = false;
    this.resetForm();
    this.showForm = true;
  }

  // Reset form data
  resetForm() {
    this.formData = {
      "partyName": "",
      "partyID": "",
      "style": "",
      "username": "",
      "userID": "",
      "assignedQty": 0,
      "formalPieces": 0,
      "casualPieces": 0,
    };
  }

  // Track by function for better performance
  trackByPartyId(index: number, party: any): any {
    return party.party_id || index;
  }

  // Track by function for stock items
  trackByStockId(index: number, stock: any): any {
    return stock.stock_id || index;
  }

  // ---- Variety chip colours -------------------------------------------------
  // The same variety always gets the same colour, so identical varieties group
  // visually down the table. The common varieties have a fixed colour; anything
  // else derives one from its own name, so a variety we have not seen before is
  // still stable rather than changing between loads.
  private varietyPalette = [
    { bg: "#e0e7ff", text: "#3730a3" },
    { bg: "#fce7f3", text: "#9d174d" },
    { bg: "#d1fae5", text: "#065f46" },
    { bg: "#fef3c7", text: "#92400e" },
    { bg: "#cffafe", text: "#155e75" },
    { bg: "#ede9fe", text: "#5b21b6" },
    { bg: "#ffe4e6", text: "#9f1239" },
    { bg: "#ecfccb", text: "#3f6212" },
  ];
  private varietyFixed = {
    PLAIN: 0,
    PRINTS: 1,
    CHECKS: 2,
    STRIPES: 3,
    MOTIF: 4,
  };
  private varietyStyleCache = {};

  varietyStyle(variety: string): any {
    const key = (variety || "").trim().toUpperCase();

    if (this.varietyStyleCache[key]) {
      return this.varietyStyleCache[key];
    }

    let style;
    if (!key) {
      style = { "background-color": "#f1f5f9", color: "#64748b" };
    } else {
      let index = this.varietyFixed[key];
      if (index === undefined) {
        // stable index from the name itself
        let hash = 0;
        for (let i = 0; i < key.length; i++) {
          hash = (hash * 31 + key.charCodeAt(i)) % 9973;
        }
        index = hash % this.varietyPalette.length;
      }
      const colour = this.varietyPalette[index];
      style = { "background-color": colour.bg, color: colour.text };
    }

    this.varietyStyleCache[key] = style;
    return style;
  }

  isFormValid(): boolean {
    if (this.isStockMode) {
      // For stock mode, only party name is required
      return !!(this.formData.partyName);
    }
    return !!(this.formData.partyName && this.formData.username && this.formData.assignedQty > 0);
  }

  submit() {
    if (!this.isFormValid()) {
      const message = this.isStockMode ?
        "Please select a party" :
        "Please fill all required fields (Party, User) and select a party with assigned quantity";

      this.toasterService.pop({
        bodyOutputType: 1,
        type: "warning",
        title: "WARNING",
        body: message,
      });
      return;
    }

    if (this.isStockMode) {
      this.submitUnlock();
    } else {
      this.submitAssignment();
    }
  }

  // NEW: Submit unlock functionality
  submitUnlock() {
    // Filter unlocked items (is_cancelled = 1)
    const unlockedItems = this.stockList.filter(item => item.is_cancelled == 1);

    if (unlockedItems.length === 0) {
      this.toasterService.pop({
        bodyOutputType: 1,
        type: "warning",
        title: "WARNING",
        body: "Please select at least one item to unlock",
      });
      return;
    }

    const formData = {
      party_id: this.formData.partyID,
      stockItems: unlockedItems.map(item => ({
        stock_id: item.stock_id,
        barcode: item.barcode,
        bag_id: item.bag_id
      }))
    };

    swal({
      title: "Are you sure to unlock selected items?",
      text: `This will unlock ${unlockedItems.length} stock items`,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, unlock them!",
      cancelButtonText: "No, cancel",
    }).then(() => {
      this.isLoading = true;

      this.whWorkOrderService.unLockWorkOrderAssign(formData)
        .then((res: any) => {
          this.isLoading = false;

          if (res.success) {
            this.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });

            this.cancelAssignment();

          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch((error: any) => {
          this.isLoading = false;
          let errorMessage = "Failed to unlock stock items";

          try {
            const errorResponse = JSON.parse(error._body);
            errorMessage = errorResponse.message || errorMessage;
          } catch (e) {
            // Use default message
          }

          swal("ERROR", errorMessage, "error");
        });
    });
  }

  // Original submit assignment functionality
  submitAssignment() {
    const selectedCount = this.getSelectedItemsCount();
    const selectedPieces = this.getSelectedPieces();

    if (selectedCount === 0) {
      this.toasterService.pop({
        bodyOutputType: 1,
        type: "warning",
        title: "WARNING",
        body: "Please select the rows you want to assign",
      });
      return;
    }

    // Only the ticked rows are assigned. Everything else is sent with
    // is_cancelled = 1, which the save skips - those rows keep their
    // wh_wo_ass_id empty and stay available to assign later.
    const stockItems = this.stockList.map(item => ({
      type: item.type,
      barcode: item.barcode,
      bag_id: item.bag_id,
      bagNo: item.bagNo,
      stock_id: item.stock_id,
      is_cancelled: this.isItemSelected(item) ? 0 : 1,
      pcs: item.pcs
    }));

    const formData = {
      userID: this.formData.userID,
      partyID: this.formData.partyID,
      style: this.formData.style,
      assignedQty: selectedPieces,
      stockItems: stockItems
    };

    const remaining = this.getSelectableItemsCount() - selectedCount;

    swal({
      title: "Are you sure to save?",
      text: remaining > 0
        ? `Assigning ${selectedCount} row(s), ${selectedPieces} pcs. The remaining ${remaining} row(s) stay available to assign later.`
        : `Assigning all ${selectedCount} row(s), ${selectedPieces} pcs.`,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(() => {
      this.isLoading = true;

      this.whWorkOrderService.saveWhWorkOrderAssign(formData)
        .then((res: any) => {
          this.isLoading = false;

          if (res.success) {
            this.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });

            // Close tab
            let tabObj = {
              action: "CloseTab",
              params: {},
            };
            this.tabUpdateEvent.emit(tabObj);

          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch((error: any) => {
          this.isLoading = false;
          let errorMessage = "Failed to save work order assignment";

          try {
            const errorResponse = JSON.parse(error._body);
            errorMessage = errorResponse.message || errorMessage;
          } catch (e) {
            // Use default message
          }

          swal("ERROR", errorMessage, "error");
        });
    });
  }

  toggleStockSelection(stockItem: any, event: any) {
    if (event.target.checked) {
      this.selectedStockItems.add(stockItem);
    } else {
      this.selectedStockItems.delete(stockItem);
      this.selectAll = false; // Uncheck select all if any item is unchecked
    }

    // Update select all state
    this.updateSelectAllState();
  }

  // NEW: Toggle all items selection
  toggleSelectAll(event: any) {
    this.selectAll = event.target.checked;

    if (this.selectAll) {
      // Select all non-cancelled items
      this.stockList.forEach(item => {
        if (item.is_cancelled != 1) {
          this.selectedStockItems.add(item);
        }
      });
    } else {
      // Deselect all items
      this.selectedStockItems.clear();
    }
  }

  // NEW: Update select all checkbox state based on individual selections
  updateSelectAllState() {
    const availableItems = this.stockList.filter(item => item.is_cancelled != 1);
    const selectedAvailableItems = availableItems.filter(item =>
      this.selectedStockItems.has(item)
    );

    this.selectAll = availableItems.length > 0 &&
      selectedAvailableItems.length === availableItems.length;
  }

  // NEW: Check if an item is selected
  isItemSelected(stockItem: any): boolean {
    return this.selectedStockItems.has(stockItem);
  }

  // NEW: Get count of selected items
  getSelectedItemsCount(): number {
    return this.selectedStockItems.size;
  }

  // How many rows can be selected at all (cancelled rows cannot)
  getSelectableItemsCount(): number {
    return this.stockList.filter(item => item.is_cancelled != 1).length;
  }

  // Pieces covered by the current selection
  getSelectedPieces(): number {
    let pieces = 0;
    this.selectedStockItems.forEach((item: any) => {
      pieces += parseInt(item.pcs || 0, 10) || 0;
    });
    return pieces;
  }

  // Select All button
  selectAllItems() {
    this.stockList.forEach(item => {
      if (item.is_cancelled != 1) {
        this.selectedStockItems.add(item);
      }
    });
    this.updateSelectAllState();
  }

  // Clear button
  clearSelection() {
    this.selectedStockItems.clear();
    this.selectAll = false;
  }

  // NEW: Bulk unlock selected items
  unlockSelectedItems() {
    if (this.selectedStockItems.size === 0) {
      this.toasterService.pop({
        bodyOutputType: 1,
        type: "warning",
        title: "WARNING",
        body: "Please select at least one item to unlock",
      });
      return;
    }

    const selectedItemsArray = Array.from(this.selectedStockItems);

    swal({
      title: `Are you sure to unlock ${selectedItemsArray.length} selected items?`,
      text: `This will unlock ${selectedItemsArray.length} stock items`,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, unlock them!",
      cancelButtonText: "No, cancel",
    }).then(() => {
      // Mark selected items as unlocked in frontend
      selectedItemsArray.forEach(item => {
        item.is_cancelled = 1;
        item.cancelled_at = new Date();
      });

      // Clear selections
      this.selectedStockItems.clear();
      this.selectAll = false;

      // Update summary counts
      this.updateStockSummary();

      this.toasterService.pop({
        bodyOutputType: 1,
        type: "success",
        title: "SUCCESS",
        body: `${selectedItemsArray.length} items unlocked successfully`,
      });
    });
  }

  // MODIFIED: Clear selections when cancelling assignment
  cancelAssignment() {
    this.showForm = false;
    this.isStockMode = false;
    this.partySearchText = '';
    this.resetForm();
    this.clearStockData();
    this.clearSelections(); // NEW: Clear selections
    this.getPartywiseAssignedDetails();
  }

  // MODIFIED: Clear selections when clearing stock data
  clearStockData() {
    this.selectedPartyForStock = null;
    this.stockList = [];
    this.stockSummary = {
      totalItems: 0,
      cancelledItems: 0,
      availableItems: 0,
      totalPieces: 0,
      cancelledPieces: 0,
      availablePieces: 0,
      totalBags: 0,
      totalIndividual: 0,
      availableBags: 0,
      availableIndividual: 0
    };
    this.clearSelections(); // NEW: Clear selections
  }

  // NEW: Clear all selections
  clearSelections() {
    this.selectedStockItems.clear();
    this.selectAll = false;
  }

  // MODIFIED: Update existing cancelStockItem method to handle selections
  cancelStockItem(stockItem: any) {
    const actionText = this.isStockMode ? "unlock" : "cancel";
    const actionTitle = this.isStockMode ? "unlock" : "cancel";

    swal({
      title: `Are you sure to ${actionTitle} this item?`,
      text: stockItem.bagNo ?
        `This will ${actionTitle} the entire bag: ${stockItem.bagNo}` :
        `This will ${actionTitle} barcode: ${stockItem.barcode}`,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: `Yes, ${actionTitle} it!`,
      cancelButtonText: "No, keep it",
    }).then(() => {
      // Mark item as cancelled/unlocked in frontend
      stockItem.is_cancelled = 1;
      stockItem.cancelled_at = new Date();

      // Remove from selected items if it was selected
      this.selectedStockItems.delete(stockItem);
      this.updateSelectAllState();

      // Update summary counts
      this.updateStockSummary();

      this.toasterService.pop({
        bodyOutputType: 1,
        type: "success",
        title: "SUCCESS",
        body: `Item ${actionText}ed successfully`,
      });
    });
  }

  // MODIFIED: Update existing restoreStockItem method to handle selections
  restoreStockItem(stockItem: any) {
    // Mark item as restored in frontend
    stockItem.is_cancelled = 0;
    stockItem.cancelled_at = null;

    // Update select all state since we now have a new available item
    this.updateSelectAllState();

    // Update summary counts
    this.updateStockSummary();

    this.toasterService.pop({
      bodyOutputType: 1,
      type: "success",
      title: "SUCCESS",
      body: "Item restored successfully",
    });
  }

  getTotalAssignedPieces(): number {
    return this.partyAssignedList.reduce((total, party) => total + (party.assignedPieces || 0), 0);
  }

  getTotalFormalPieces(): number {
    return this.partyAssignedList.reduce((total, party) => total + (party.formalPieces || 0), 0);
  }

  getTotalCasualPieces(): number {
    return this.partyAssignedList.reduce((total, party) => total + (party.casualPieces || 0), 0);
  }

  getTotalFsPieces(): number {
    return this.partyAssignedList.reduce((total, party) => total + (party.totalFs || 0), 0);
  }

  getTotalHsPieces(): number {
    return this.partyAssignedList.reduce((total, party) => total + (party.totalHs || 0), 0);
  }
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/phase1/WhWorkOrderAssign/addWhWorkOrderAssign.ts